module.exports = __webpack_public_path__ + "static/media/lever_touch_logo.23a0e393.png";